const sanitizeHtml = require('sanitize-html')
const { mapCategoriestoSlugs } = require('../blogPosts/mapCategoriestoSlugs')

const WORDS_PER_MINUTE = 300
const ARTICLE_SHORTEN_LENGTH = 180
const ARTICLE_REGEX = /\w+/g
const getWordCount = (article) => article.match(ARTICLE_REGEX).length

const removeTagsAndNewLines = (str) => {
  if (!str) return ''
  return sanitizeHtml(str, { allowedTags: [] })
    .replace(/\n/g, '')
    .replace(/&amp;/gm, '&')
    .replace(/&nbsp;/gm, ' ')
    .replace(/&quot;/gm, '"')
    .replace(/&apos;/gm, "'")
    .replace(/&lt;/gm, '<')
    .replace(/&gt;/gm, '>')
}

const reduceContent = (content, shortenTo = ARTICLE_SHORTEN_LENGTH) => {
  if (!content?.length) return ''
  return removeTagsAndNewLines(content).slice(0, shortenTo).concat('...')
}

const getReadingTime = (article) => {
  if (!article) return 1
  const wordCount = getWordCount(removeTagsAndNewLines(article))
  return Math.ceil(wordCount / WORDS_PER_MINUTE)
}

const getUpdateCoverImage = (blog) => {
  const mediaSrc = blog?.node?.blogPost?.heroOptions?.mediaSrc
  const mediaType = blog?.node?.blogPost?.heroOptions?.mediaType
  if (
    mediaSrc &&
    typeof mediaSrc === 'string' &&
    Array.isArray(mediaType) &&
    mediaType.length > 0 &&
    mediaType?.includes('Image')
  ) {
    return mediaSrc
  }
  if (
    mediaType?.includes('Video') &&
    blog?.node?.blogPost?.heroOptions?.coverImage
  ) {
    return blog?.node?.blogPost?.heroOptions?.coverImage
  }
  return null
}

const formatArticlesForAuthorBio = (articles) => {
  const formatedStubs = articles.map((blog) => {
    const urlPath = mapCategoriestoSlugs(blog.node?.categories?.nodes)
    return {
      author: blog.node?.author?.node?.userProfile?.fullName,
      title: blog.node?.title,
      slug: blog.node?.slug,
      date: blog.node?.date,
      url: `/${urlPath}/${blog.node?.slug}/`,
      excerpt: blog.node.excerpt || '',
      readingTime: getReadingTime(blog?.node?.content),
      content: reduceContent(blog?.node?.content),
      coverImage: blog?.node?.blogPost?.heroOptions?.coverImage
    }
  })
  return formatedStubs || []
}

const filterAuthorByAuthorName = (authorName, blogs) => {
  return blogs.filter((blog) => blog.author === authorName)
}

module.exports = {
  formatArticlesForAuthorBio,
  filterAuthorByAuthorName,
  removeTagsAndNewLines,
  getReadingTime,
  getWordCount,
  reduceContent,
  WORDS_PER_MINUTE,
  ARTICLE_SHORTEN_LENGTH,
  ARTICLE_REGEX
}
